/** Peso del criterio (default 1). */
export function questionWeight(question: any): number {
  return question?.score ?? 1;
}

/** Indica si el criterio tiene subcriterios. */
function hasSubs(question: any): boolean {
  return (question?.subitems || []).length > 0;
}

/** Suma los pesos de los subcriterios. */
function sumSubitems(subitems: any[]): number {
  let total = 0;
  for (const sub of (subitems || [])) total = addWeight(total, sub);
  return total;
}

/** Suma el peso de un criterio con sus subcriterios. */
function addWeight(total: number, question: any): number {
  return total + criterionWeight(question);
}

/** Peso del criterio: suma de subcriterios si tiene, o su score. */
export function criterionWeight(question: any): number {
  if (hasSubs(question)) return sumSubitems(question.subitems);
  return questionWeight(question);
}

/** Suma los pesos de las preguntas de la categoría. */
function sumQuestions(questions: any[]): number {
  let total = 0;
  for (const question of (questions || [])) total = addWeight(total, question);
  return total;
}

/** Calcula el puntaje total recursivo de la categoría. */
export function categoryScore(category: any): number {
  return sumQuestions(category?.questions);
}

/** Clona una categoría con su puntaje total. */
function withScore(category: any): any {
  return { ...category, totalScore: categoryScore(category) };
}

/** Clona las categorías agregando el puntaje total. */
export function withCategoryScores(categories: any[]): any[] {
  const out: any[] = [];
  for (const category of (categories || [])) out.push(withScore(category));
  return out;
}
